import fastJsonPatch from "fast-json-patch";
export const applyJSONPatch = (previous, patch) => {
    const result = fastJsonPatch.applyPatch(previous, patch, true, false);
    return result.newDocument;
};
